document.addEventListener('DOMContentLoaded', function() {
     function moveQuickShopModals() {
        document.querySelectorAll('.swiper .modal--quick-shop').forEach(function(modal) {
          if (modal.parentElement && !modal.parentElement.isSameNode(document.body)) {
            document.body.appendChild(modal);
          }
        });
      }

      moveQuickShopModals();

      // 動的に追加されるモーダルにも対応
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length) {
            moveQuickShopModals();
          }
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
});


// Quick View内アコーディオン対応（モーダル内のみに限定）
jQuery(document).on('click', '.modal--quick-shop .js--toggle', function () {
  jQuery(this).toggleClass('is-open');
  jQuery(this).next(".accordion-text").find(".overview").slideToggle(300);
});

jQuery(document).on('click', '.modal--quick-shop .js--toggle2', function () {
  jQuery(this).toggleClass('is-open');
  jQuery(this).next(".accordion-text").find(".productdetail").slideToggle(300);
});






